import React from 'react';
import { ENVIRONMENTS } from '../../services/exports/Constants';

export default function EnvironmentBanner() {
  const env = import.meta.env.VITE_APP_MODE;
  const show = ![ENVIRONMENTS.PROD, ENVIRONMENTS.LOCAL, undefined].includes(env);

  function getBackgroundColor() {
    switch (import.meta.env.VITE_APP_MODE) {
      case ENVIRONMENTS.DEV:
        return '#000000';
      case ENVIRONMENTS.STAGING:
        return '#F89A2A';
      default:
        return '';
    }
  }

  return (
    show && (
      <div className="h-8 w-full flex justify-center" style={{ backgroundColor: getBackgroundColor() }}>
        <h6 className="my-auto text-white">{env}</h6>
      </div>
    )
  );
}
